export default __webpack_public_path__ + "static/media/7.36abf2c5.jpg";